import ArchesLogo from '../../assets/icons/ArchesLogo.svg?react';

// Single source for the brand lockup; its two fills are bound to the Arches tokens.
const BrandLogo = ({ className = '' }) => (
    <ArchesLogo role="img" aria-label="ARCHES" className={className} />
);

export default BrandLogo;
